import { BaseController } from '../../../../../../../common/base/controller';

import { MODEL_FIELDS } from '../../createRequest.model';

export class BranchIdsController extends BaseController {
  constructor($scope, controllerService) {
    'ngInject';
    super({
      $scope,
      controllerService,
    });
  }

  getLabelFor(field) {
    return `receiving.createRequest.form.${field}`;
  }

  $onInit() {
    this.MODEL_FIELDS = MODEL_FIELDS;

    // Branch ids to choose from are passed in via the `branchIds` binding.
    // Normalize to `{ value }` objects so the select can display them as
    // label (selectKey) and store the id in the model (modelKey).
    this.branchIdOptions = {
      orderKeys: false,
      searchEnabled: true,
      selectKey: 'value',
      modelKey: 'value',
      selectables: (this.branchIds || []).map((branchId) => ({
        value: `${branchId}`,
      })),
    };
  }
}
